import React from 'react';
import { LazyComponent } from '@fiverr-private/ui_utils';
import { logger } from '@fiverr-private/obs';
import { user } from '../../../PropTypes';

const lazyImport = () =>
    import(/* webpackChunkName: 'FiverrEmbedSellerStatus' */ './FiverrEmbedSellerStatus').then((module) => ({
        default: module.default,
    }));

const onError = (error) =>
    logger.error('[LazyFiverrEmbedSellerStatus] Failed to lazy load FiverrEmbedSellerStatus', {
        error: error instanceof Error ? error.message : String(error),
        stack: error instanceof Error ? error.stack : undefined,
    });

const LazyFiverrEmbedSellerStatus = (_props, { user }) => {
    if (!user?.embed) {
        return null;
    }

    return <LazyComponent lazyImport={lazyImport} componentProps={{}} onError={onError} placeholder={undefined} />;
};

LazyFiverrEmbedSellerStatus.contextTypes = {
    user,
};

export default LazyFiverrEmbedSellerStatus;
